























































import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { ICatalogFilterItemOption } from '~/assets/interfaces/catalog'

@Component
export default class ComponentCatalogFilterRange extends Vue {
  @Prop({ type: Object, default: () => ({ min: 0, max: 0 }) })
  private options!: ICatalogFilterItemOption

  // Применён ли сейчас этот фильтр (его ключ есть в query). Нужно для
  // границ ползунка, см. bounds.
  @Prop({ type: Boolean, default: false }) private applied!: boolean

  private min = 0
  private max = 0

  // Границы, «подсмотренные» в ответе без фильтра — единственный ответ, где
  // min/max означают полный диапазон, а не выбранные значения.
  private learnedMin: number | null = null
  private learnedMax: number | null = null

  @Watch('options', { immediate: true })
  private optionsHandler(val: ICatalogFilterItemOption) {
    this.min = val.min
    this.max = val.max
    if (!this.applied) {
      this.learnedMin = val.min
      this.learnedMax = val.max
    }
  }

  // Границы ползунка. Надёжный источник — rangeMin/rangeMax от бэка. Без них
  // берём границы из ответа без фильтра; если фильтр применён с первой
  // загрузки (deep-link), полный диапазон неизвестен — ползунок не показываем,
  // остаются поля. Ответы с применённым фильтром границы не меняют: там
  // min/max — эхо ввода пользователя, а не диапазон.
  private get bounds(): { min: number; max: number } | null {
    const { rangeMin, rangeMax } = this.options
    if (typeof rangeMin === 'number' && typeof rangeMax === 'number') {
      return { min: rangeMin, max: rangeMax }
    }
    if (this.learnedMin !== null && this.learnedMax !== null) {
      return { min: this.learnedMin, max: this.learnedMax }
    }
    return null
  }

  private get boundMin() {
    return this.bounds ? this.bounds.min : 0
  }

  private get boundMax() {
    return this.bounds ? this.bounds.max : 0
  }

  private get hasSlider() {
    return !!this.bounds && this.boundMax > this.boundMin
  }

  // Шаг — примерно сотая диапазона, округлённая до «круглого» числа: на
  // цене до 43 000 ползунок идёт по 100 ₽, а не дёргается по рублю.
  private get step() {
    const raw = (this.boundMax - this.boundMin) / 100
    if (raw <= 1) {
      return 1
    }
    return Math.pow(10, Math.floor(Math.log10(raw)))
  }

  private percent(value: number) {
    const clamped = Math.min(Math.max(value, this.boundMin), this.boundMax)
    return ((clamped - this.boundMin) / (this.boundMax - this.boundMin)) * 100
  }

  private get styleFill() {
    return {
      left: `${this.percent(this.min)}%`,
      right: `${100 - this.percent(this.max)}%`,
    }
  }

  // Ползунки не заходят друг за друга.
  private inputSliderFrom(e: Event) {
    const value = Number((e.target as HTMLInputElement).value)
    this.min = Math.min(value, this.max)
    ;(e.target as HTMLInputElement).value = String(this.min)
  }

  private inputSliderTo(e: Event) {
    let value = Number((e.target as HTMLInputElement).value)
    // Браузер округляет значение до шага от минимума, и 42 999 при шаге 100
    // от 1 недостижимо: у правого края подставляем саму границу.
    if (value + this.step > this.boundMax) {
      value = this.boundMax
    }
    this.max = Math.max(value, this.min)
    ;(e.target as HTMLInputElement).value = String(this.max)
  }

  // Фильтр применяем, когда ползунок отпустили, а не на каждом шаге. Всегда
  // отдаём текущую пару значений: options могут быть уже устаревшими, если
  // предыдущее изменение ещё в пути.
  private emitChange() {
    this.$emit('change', {
      min: this.min,
      max: this.max,
    })
  }

  // Ручной ввод: не число или пусто — возвращаем прежнее значение; известны
  // границы — не выпускаем за них; «от» не больше «до».
  private parseInput(e: Event, fallback: number) {
    const input = e.target as HTMLInputElement
    let value = Number(input.value)
    if (input.value.trim() === '' || isNaN(value)) {
      value = fallback
    }
    if (this.bounds) {
      value = Math.min(Math.max(value, this.bounds.min), this.bounds.max)
    }
    return value
  }

  private changeHandlerFrom(e: Event) {
    this.min = Math.min(this.parseInput(e, this.min), this.max)
    ;(e.target as HTMLInputElement).value = String(this.min)
    this.emitChange()
  }

  private changeHandlerTo(e: Event) {
    this.max = Math.max(this.parseInput(e, this.max), this.min)
    ;(e.target as HTMLInputElement).value = String(this.max)
    this.emitChange()
  }

  private isFocusFrom = false
  private isFocusTo = false

  private focusFrom() {
    this.isFocusFrom = true
  }

  private focusTo() {
    this.isFocusTo = true
  }

  private blurFrom() {
    this.isFocusFrom = false
  }

  private blurTo() {
    this.isFocusTo = false
  }

  private $style!: IStyle

  private get classItemFrom() {
    return {
      [this.$style.item]: true,
      [this.$style.focus]: this.isFocusFrom,
    }
  }

  private get classItemTo() {
    return {
      [this.$style.item]: true,
      [this.$style.focus]: this.isFocusTo,
    }
  }
}
